import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "./useApiClient";

export type Me = {
  name: string | null;
  email: string | null;
  oid: string | null;
  tenantId: string | null;
  roles: string[];
  isAdmin: boolean;
  isAccounting: boolean;
  isPurchasing: boolean;
  isSales: boolean;
};

// Perfil + flags de acceso desde GET /api/me. Los flags salen de las allowlists
// del backend (ADMIN_EMAILS / ACCOUNTING_EMAILS / PURCHASING_EMAILS /
// SALES_EMAILS) — nada se hornea ya en el bundle público, y cambiar una lista
// solo pide reiniciar la API. UX-only: el enforcement real siguen siendo las
// policies "Admin"/"Accounting" del backend.
export function useMe() {
  const { request } = useApiClient();
  return useQuery<Me>({
    queryKey: ["me"],
    queryFn: () => request<Me>("/me"),
    // Las allowlists solo cambian con un reinicio de la API: sin refetches.
    staleTime: Infinity,
  });
}
